import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";

export const ModalInspecciones = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuarioweb = JSON.parse(localStorage.getItem("idusuarioweb"));

  const [imagen, setImagen] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });

  const [pathImage, setPathImage] = useState({
    imagen: `${op.servidor}/inspecciones?img=subir.png`,
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [minas, setMinas] = useState([]);
  const [materiales, setMateriales] = useState([]);
  const [fiscales, setFiscales] = useState([]);
  const [values, setValues] = useState({
    idcontrolguia: "",
    idguia: "",
    idmina: "",
    idusuarioapp: "",
    estatus: 0,
    material: "",
    cedula: "",
    chofer: "",
    placa: "",
    destino: "",
    ne: "",
    metroscubicos: 0.0,
    motivo: "",
    fecha: fechaSistema,
    hora: moment().format("hh:mm"),
    factura: "",
    motivo: ""
  });
  const [deshabilitado, setDeshabilitado] = useState(false);

  const txtCedula = useRef();
  const txtNombre = useRef();
  const txtMetrosCubicos = useRef();
  const txtObservacion = useRef();

  const cmbMinas = useRef();
  const cmbFiscales = useRef();
  const cmbMateriales = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const onChange = (event) => {
    event.target.value = event.target.value.toUpperCase();

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeT = (event) => {
    if (event.which === 13) {
      if (event.target.name === "cedula") {
        txtNombre.current.focus();
      }
    }
  };

  const handleUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const name = e.target;

      if (file.type.includes("image")) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        if (name.name === "imagen") {
          reader.onload = function load() {
            setPathImage({ ...pathImage, imagen: reader.result });
          };
        }
      }

      if (name.name === "imagen") {
        setImagen({ ...imagen, [e.target.name]: e.target.files[0] });
      }
    }
  };


  const cargaragentesmina = () => {
    setActivate(true);

    let campos = `trim(nombre) as nombre, idagente, idtipoente`;
    let nomtab = "agente";
    let condi = `mina=true`;
    let orden = "idagente asc";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMinas(response.data);
        }
      })
      .catch(function (error) {
        console.error(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const cargarmateriales = () => {
    setActivate(true);

    let campos = `*`;
    let nomtab = "claseminas";
    let orden = "idclaseminas asc";

    let endpoint = `${op.conexion}/api/inspeccion/consultar?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMateriales(response.data);
        }
      })
      .catch(function (error) {
        console.error(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const cargaragentesfiscal = () => {
    setActivate(true);

    let campos = `*`;
    let nomtab = "usuarioapp";
    let orden = "idusuario asc";

    let endpoint = `${op.conexion}/api/inspeccion/consultar?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFiscales(response.data);
        }
      })
      .catch(function (error) {
        console.error(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;

    /*     if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir la Cedula del Chofer.",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (txtMonto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el valor estimado.",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (
      !tramite.fijo &&
      (txtValorute.current.value.trim() === "" ||
        txtValorute.current.value.trim() === "0,00")
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el valor UTE.",
        icono: "informacion",
      });
      sigue = false;
      txtValorute.current.focus();
    } else if (
      !tramite.fijo &&
      (txtMontoCapital.current.value.trim() === "" ||
        txtMontoCapital.current.value.trim() === "0,00")
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe introducir el " + tramite.titulo,
        icono: "informacion",
      });
      sigue = false;
      txtMontoCapital.current.focus();
    } 
     */

    if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/inspeccion/actualizar/${props.operacion}`;
    setActivate(true);

    let data = [];
    data.push({
      idcontrolguia: values.idcontrolguia,
      idguia: values.idguia,
      idmina: values.idmina,
      idusuarioapp: values.idusuarioapp,
      estatus: values.estatus,
      material: values.material,
      cedula: values.cedula,
      chofer: values.chofer,
      placa: values.placa,
      destino: values.destino,
      ne: values.ne,
      metroscubicos: parseFloat(
        txtMetrosCubicos.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", ".")
      ),
      motivo: values.motivo,
      fecha: values.fecha,
      hora: values.hora,
      factura: values.factura,
      motivo: values.motivo
    });

    let upload = new FormData();

    upload.append("inspeccion", JSON.stringify(data));
    upload.append("imagenactual", imagen.imagenactual);
    upload.append("imagennueva", imagen.imagen);

    axios
      .post(endpoint, upload, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    let mon = 0.0;
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.target.name === "metroscubicos") {
        mon = parseFloat(
          event.target.value.trim().replace(/\./g, "").replace(",", ".")
        );

        setValues({ ...values, metroscubicos: mon });
        txtMetrosCubicos.current.value = formatMoneda(
          mon.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const blanquear = () => {
    setActivate(false);
    setDeshabilitado(false);
    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage({ imagen: op.servidor + "/inspecciones?img=subir.png" });
    setValues({
      idcontrolguia: "",
      idguia: "",
      idmina: "",
      idusuarioapp: "",
      estatus: 0,
      material: "",
      cedula: "",
      chofer: "",
      placa: "",
      destino: "",
      ne: "",
      metroscubicos: 0.0,
      motivo: "",
      fecha: fechaSistema,
      hora: moment().format("hh:mm"),
      factura: "",
      motivo: ""
    });
  };

  const cargarimagen = (ruta) => {
    window.open(ruta, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  }
  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHide(true);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        cargaragentesmina();
        cargarmateriales();
        cargaragentesfiscal();

        if (props.operacion !== 1) {
          setValues(props.inspeccion);
          if (
            props.inspeccion.imagen.trim() !== "subir.png" &&
            props.inspeccion.imagen.trim() !== null &&
            props.inspeccion.imagen.trim() !== ""
          ) {
            setImagen({ ...imagen, imagenactual: props.inspeccion.imagen.trim() });
            setPathImage({
              imagen:
                op.servidor + "/inspecciones?img=" + props.inspeccion.imagen.trim(),
            });
          }
      
          txtMetrosCubicos.current.value = formatMoneda(
            props.inspeccion.metroscubicos
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          if (props.operacion === 2) {
            setDeshabilitado(false);
          } else {
            setDeshabilitado(true);
          }
        } else {
            txtMetrosCubicos.current.value = "0,00";
            setDeshabilitado(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>Inspeccion.</Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body
        className="amanecergris"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ height: "65vh", overflow: "auto" }}>
          <div
            className="row col-md-12"
            style={{ fontFamily: "Times New Roman, Times, serif" }}
          >
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Datos de la Inspeccion
              </legend>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Minas:
                </label>
                <select
                  name="idmina"
                  disabled={deshabilitado}
                  value={values &&  values.idmina}
                  className="form-control"
                  ref={cmbMinas}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione una mina -</option>
                  {minas &&
                    minas.map((item, i) => (
                      <option key={i} value={item.idagente}>
                        {item.nombre}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Material:
                </label>
                <select
                  name="material"
                  disabled={deshabilitado}
                  value={values &&  values.material}
                  className="form-control"
                  ref={cmbMateriales}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione el material -</option>
                  {materiales &&
                    materiales.map((item, i) => (
                      <option key={i} value={item.idclaseminas}>
                        {item.descripcion}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Inspector:
                </label>
                <select
                  name="idusuarioapp"
                  disabled={deshabilitado}
                  value={
                    values && values.idusuarioapp
                  }
                  className="form-control"
                  ref={cmbFiscales}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione un Inspector -</option>
                  {fiscales &&
                    fiscales.map((item, i) => (
                      <option key={i} value={item.idusuario}>
                        {item.login.toUpperCase()}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Destino:
                </label>
                <input
                  type="text"
                  name="destino"
                  disabled={deshabilitado}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.destino}
                  className="form-control uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="destino"
                />
              </div>
              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Nro Guia:
                </label>
                <input
                  type="text"
                  name="idguia"
                  disabled={deshabilitado}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.idguia}
                  className="form-control uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="guia"
                />
              </div>

              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Nro Nota Entrega:
                </label>
                <input
                  type="text"
                  name="ne"
                  disabled={deshabilitado}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.ne}
                  className="form-control uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0000"
                />
              </div>

              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Nro Factura:
                </label>
                <input
                  type="text"
                  name="factura"
                  disabled={deshabilitado}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.factura}
                  className="form-control uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="Factura"
                />
              </div>

              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee" }}
                  id="inputGroup-sizing-sm"
                >
                  Metros Cubicos
                </label>
                <input
                  type="text"
                  name="metroscubicos"
                  ref={txtMetrosCubicos}
                  disabled={deshabilitado}
                  onFocus={seleccionarCampo}
                  defaultValue="0,00"
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  autoComplete="off"
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  title="metros cubicos"
                />
              </div>

              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Fecha:
                </label>
                <input
                  type="date"
                  name="fecha"
                  disabled={deshabilitado}
                  autoComplete="off"
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={moment(values.fecha).format("YYYY-MM-DD")}
                  className="form-control uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  title="Fecha"
                />
              </div>

              <div className="input-group input-group-sm col-sm-4 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Hora:
                </label>
                <input
                  type="time"
                  name="hora"
                  disabled={deshabilitado}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.hora}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  title="Hora"
                />
              </div>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  Observacion:
                </label>
                <input
                  type="text"
                  name="motivo"
                  disabled={deshabilitado}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.motivo}
                  className="form-control uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="observacion"
                />
              </div>
            </fieldset>

            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                <legend
                  className="float-none w-auto"
                  style={{ fontSize: "15px" }}
                >
                  Datos del Chofer
                </legend>

                <div className="input-group input-group-sm col-sm-4 mb-3">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "#55acee", fontSize: 12 }}
                    id="inputGroup-sizing-sm"
                  >
                    Cedula Chofer:
                  </label>
                  <input
                    type="text"
                    disabled={deshabilitado}
                    name="cedula"
                    autoComplete="off"
                    ref={txtCedula}
                    onChange={onChange}
                    onKeyUp={onChangeT}
                    value={values.cedula}
                    className="form-control uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    placeholder="V12345678"
                    title="CEDULA"
                    maxLength={11}
                  />

                </div>

                <div className="input-group input-group-sm col-sm-4 mb-3">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee", fontSize: 12 }}
                      id="inputGroup-sizing-sm"
                    >
                      Placa Vehiculo:
                    </label>
                    <input
                      type="text"
                      name="placa"
                      disabled={deshabilitado}
                      autoComplete="off"
                      onChange={onChange}
                      onKeyUp={onChangeT}
                      value={values.placa}
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      placeholder="PLACA"
                      title="PLACA"
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-12 mb-3">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee", fontSize: 12 }}
                      id="inputGroup-sizing-sm"
                    >
                      Nombre Chofer:
                    </label>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      name="chofer"
                      autoComplete="off"
                      onChange={onChange}
                      onKeyUp={onChangeT}
                      value={values.chofer}
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      placeholder="Chofer"
                    />
                  </div>
              </fieldset>

              <div className="row col-md-12">
                    <div
                      className="row col-md-6 mx-auto d-flex justify-content-center py-2"
                      style={{ height: 150, width: 150 }}
                    >
                      <div className="col-md-12 mx-auto d-flex justify-content-center">
                        <img
                          src={pathImage.imagen}
                          className="shadow position-absolute"
                          style={{ height: 150, width: 150 }}
                          alt=""
                          onClick={() => cargarimagen(pathImage.imagen)}
                        />
                       {/*  <input
                          type="file"
                          disabled={deshabilitado}
                          style={{
                            opacity: 0,
                            height: 150,
                            width: 150,
                          }}
                          onChange={handleUpload}
                          name="imagen"
                          accept="image/jpeg, image/png"
                          className="btn rounded-circle"
                        /> */}
                      </div>
                    </div>
                </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={props.operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/fiscales/modalinspecciones.js